<dialog-header
  title="Select Reward"
  (onClose)="matDialogRef.close()"
></dialog-header>

<div
  mat-dialog-content
  style="
    border-top: 1px solid lightgray;
    border-bottom: 1px solid lightgray;
    background-color: var(--app-container);
  "
>
  <form [formGroup]="form" style="margin-top: 20px">
    <div class="form-field" *ngIf="!data?.customer">
      <single-select
        label="Give To"
        [formCtrl]="recipientTypeFormControl"
        [value]="recipientTypeFormControl.value"
        [options]="recipientTypeOptions"
        property="label"
        [showIcon]="false"
      ></single-select>
    </div>

    <div
      class="form-field"
      style="margin-top: 20px"
      *ngIf="!data?.customer && isSpecificCustomer"
    >
      <single-select
        label="Customer"
        inBrackets="email"
        [formCtrl]="customerFormControl"
        [value]="customerFormControl.value"
        [options]="customers"
        property="name"
        [showIcon]="false"
        [showSearch]="true"
      ></single-select>
    </div>

    <div
      class="form-field"
      style="margin-top: 20px"
      *ngIf="!data?.customer && isEmailRecipient"
    >
      <div class="form-field-label">
        Email Address<span style="color: red">*</span>
      </div>
      <input
        class="form-input"
        autocomplete="off"
        [formControl]="emailFormControl"
        type="email"
        placeholder="Enter recipient email address"
      />
    </div>

    <div class="form-field" style="margin-top: 20px">
      <single-select
        label="Reward"
        [formCtrl]="rewardFormControl"
        [value]="rewardFormControl.value"
        [options]="rewards"
        [inBrackets]="'description'"
        property="title"
        [showIcon]="false"
        (click)="hasRewards()"
      ></single-select>
    </div>

    <div class="form-field" style="margin-top: 20px">
      <single-select
        label="Quantity"
        [formCtrl]="numberFormControl"
        [value]="numberFormControl.value"
        property="number"
        [options]="quantityOptions"
        [showIcon]="false"
      ></single-select>
    </div>

    <div
      class="form-field"
      style="margin-top: 20px; display: flex; justify-content: space-between"
      *ngIf="data?.customer || isSpecificCustomer"
    >
      <div class="form-field-label">Notify customer via push notification</div>
      <mat-slide-toggle
        [disabled]="false"
        [checked]="notify"
        (change)="notify = !notify"
      >
      </mat-slide-toggle>
    </div>

    <div
      class="form-field"
      style="margin-top: 20px; display: flex; justify-content: space-between"
      *ngIf="!data?.customer && isEmailRecipient"
    >
      <div class="form-field-label">Send email invitation</div>
      <mat-slide-toggle
        [disabled]="false"
        [checked]="sendEmail"
        (change)="sendEmail = !sendEmail"
      >
      </mat-slide-toggle>
    </div>
  </form>
</div>

<div mat-dialog-actions align="end">
  <app-secondary-button
    style="margin-right: 10px"
    [title]="'Cancel'"
    [disabled]="false"
    (tapped)="matDialogRef.close()"
  ></app-secondary-button>

  <app-primary-button
    [title]="'Next'"
    [disabled]="!merchantActive"
    [tooltip]="!merchantActive ? 'Merchant account inactive' : ''"
    (tapped)="primaryTapped()"
    bgColor="var(--app-timber)"
    color="white"
  ></app-primary-button>
</div>

<loader [loading]="rewardsLoading || customersLoading || saving"></loader>
